/** Formatea un valor numérico sin exponer valores no finitos. */
export const fmt = value => Number.isFinite(value) ? String(Number(value.toFixed(2))) : '—';

/** Convierte minutos decimales a una hora con precisión de segundos. */
export const timeLabel = minute => [Math.floor(minute / 60), Math.floor(minute % 60), Math.round(minute * 60) % 60].map(part => String(part).padStart(2, '0')).join(':');

/**
 * Recorre el modelo de presentación y reemplaza valores no representables.
 *
 * @param {*} value - Valor o estructura que será entregada al template.
 * @returns {*} Copia segura para atributos, estilos y contenido React.
 */
export const safeValues = value => {
  if (typeof value === 'number' && !Number.isFinite(value)) return '—';
  if (typeof value === 'string' && /NaN|Infinity/.test(value)) {
    if (/^M/.test(value)) return 'M0 0';
    if (/^(?:rgba?|oklch)\(/.test(value)) return 'transparent';
    return value.replace(/NaN|-?Infinity/g, '—');
  }
  if (Array.isArray(value)) return value.map(safeValues);
  if (!value || typeof value !== 'object' || value.$$typeof || Object.getPrototypeOf(value) !== Object.prototype) return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, safeValues(item)]));
};
